var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.995.22C10.835.22 14 3.228 14 6.951c0 1.877-.694 3.619-1.837 5.095A18.053 18.053 0 017.6 16.21c-.4.257-.762.276-1.2 0a17.705 17.705 0 01-4.563-4.162C.693 10.571 0 8.83 0 6.952 0 3.23 3.166.22 6.995.22zm0 4.675c-1.27 0-2.306 1.03-2.306 2.267 0 1.247 1.036 2.228 2.306 2.228S9.31 8.41 9.31 7.162c0-1.238-1.046-2.267-2.316-2.267z"
  })));
}

export default __webpack_public_path__ + "20f3dcf65e7c888fd9127366b82bd133.svg";
export { SvgLocation as ReactComponent };